import axios from 'axios'

export default {
  namespaced: true,
  state: {
    userName: '',
    userFullName: '',
    clientCode: '',
    clientId: '',
    clientName: '',
    clientStatus: 'ACTIVE',
    currentJob: '',
    availableJobs: [],
    roles: [],
    is_mfa_enabled: false,
    is_mfa_required: false
  },

  mutations: {
    setUserData (state, data) {
      state.userFullName = data.name
      state.userName = data.email
      state.roles = data.role.split(',')

      if (state.clientCode === null || !state.roles.includes('admin')) {
        state.clientCode = data.clientcode
        state.clientId = data.client_id
        state.clientName = data.clientname
        state.clientStatus = data.clientStatus
      }

      // state.clientCode = 'btmic'
      // state.clientId = 'cd7801e57733424d835b268cbc73c360'
      // state.clientName = 'BTMic123'

      state.is_mfa_enabled = data.is_mfa_enabled
      state.is_mfa_required = data.is_mfa_required
    },

    setIsMfaEnabled (state, data) {
      state.is_mfa_enabled = data
    },

    setCurrentClient (state, data) {
      state.clientCode = data.client
      state.clientId = data.client_id
      state.clientName = data.client_name
      state.clientStatus = data.clientStatus
    }
  },

  getters: {
    isInRole: (state) => (role) => {
      return state.roles.includes(role) || state.roles.includes('admin')
    },

    shouldEnableMFA: (state) => {
      return state.is_mfa_required && !state.is_mfa_enabled
    }
  },

  actions: {
    getCurrentUserData ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API + 'user/profile').then(data => {
          commit('setUserData', data.data)
          resolve()
        })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js